import { getDefinitionByName } from "@goodgamestudios/createjs-utilities";

import Container = createjs.Container;
import DropShadowFilter = createjs.DropShadowFilter;
import GlowFilter = createjs.GlowFilter;
import Rectangle = createjs.Rectangle;

export class CardHelper {
    private static glowfilter: GlowFilter;
    private static shadowfilter: DropShadowFilter;

    public static drawCard(id: string, maxHeight: number = -1, maxWidth: number = -1, highlightCards: any[] = null): Container {
        var itemMC: Container = new Container();
        try {
            var mcClass: any = getDefinitionByName("Card_" + id) as any;
            itemMC = new mcClass();
            //itemMC.cacheAsBitmap = true;
            if (maxHeight > 0 && maxWidth > 0) {
                var bounds: Rectangle = itemMC.getBounds(null);
                var scaleFactor: number = (maxWidth / bounds.width);
                if ((bounds.height * scaleFactor) > maxHeight)
                    scaleFactor = (maxHeight / bounds.height);
                itemMC.scaleX = itemMC.scaleY = scaleFactor;
                itemMC.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
                itemMC.y = - ((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));
                itemMC.useFilters([CardHelper.shadowfilter]);
            }
            if (highlightCards) {
                if (highlightCards.indexOf(id) >= 0) {
                    itemMC.filters = [CardHelper.shadowfilter, CardHelper.glowfilter];
                    itemMC.y -= 4;
                }
                else {
                    itemMC.alpha = 0.7;
                }
            }

        } catch (e) {
            //trace(e.message);
        }
        return itemMC;
    }

    public static __initialize_static_members() {
        CardHelper.glowfilter = CardHelper.glowfilter = new GlowFilter(0xFFF7E6, 0.8, 10, 10, 3, 3);
        CardHelper.shadowfilter = new DropShadowFilter(1.5, 45, 0x000000, 0.5, 2, 2);
    }
}
CardHelper.__initialize_static_members();
